import React, { useState } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { FormHelperText, Input } from "@mui/material";
import "./custom__select-box.css";
import { useEffect } from "react";
const CustomSelectBox = ({
  value,
  selectedValue ,
  onChange,
  title,
  items,
  name,
  placeholder,
  className,
  ...rest
}) => {

  const [defaultValue , setDefaultValue] = useState("")

  useEffect(()=>{
    if(selectedValue === undefined){
      // console.log('selectedValue == "undefined" ',selectedValue == "undefined")
      setDefaultValue("")
    }
    else setDefaultValue(selectedValue)

    // console.log('selectedValue == "undefined" ',selectedValue === undefined , selectedValue)
  }, [])

  return (
    <FormControl {...rest} fullWidth className="custom__select-box">
      <InputLabel id="demo-simple-select-label">{title}</InputLabel>
      <Select
        className={className}
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={value}
        label={title}
        onChange={onChange}
        name={name}
        defaultValue={defaultValue}
        placeholder={placeholder}
      >
        <MenuItem className="menu_item"  key="key1" value={""}>Choose {title}</MenuItem>
        { (items).map((item,i) => {
          // console.log("Custom Select box ", item , selectedValue , defaultValue)
          return <MenuItem key={i} selected={ selectedValue===item  } className="menu_item" value={item}>{item}</MenuItem>;
        })}
      </Select>
    </FormControl>
  );
};

export default CustomSelectBox;
